import { gql } from '@apollo/client'

const CHECK_SUBMIT_VALIDATION_CRITERIA = gql`
  mutation SubmitDealInformationValidation($input: BjfSubmitDealInformationValidationInput!) {
    bjfSubmitDealInformationValidation(input: $input) {
      errors {
        message
      }
      isSuccess
    }
  }
`

export default CHECK_SUBMIT_VALIDATION_CRITERIA
